import React from 'react';
import {get} from 'lodash';
import {gql} from 'apollo-boost';

import client from '../../src/graphql/client';

import refactorBreadcrumbsData from '../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';
import refactorHb from '../../src//data-restructure/multimedia/hero-banner-small-v2-2023';
import respImgQuery from '../../src/graphql/queries/resp-img';
import refactorRespImg from '../../src/data-restructure/ui/resp-img';
import seoQuery from '../../src/graphql/queries/seo';

import CommunityPage from '../../src/containers/Community';

const Community = (props) => {
  return (
    <CommunityPage
      {...props}
    />
  )
}

export async function getStaticProps() {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const region = countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz';
  const domain = process.env.DEV_ASSIGNED_DOMAIN ? process.env.DEV_ASSIGNED_DOMAIN : process.env.ASSIGNED_DOMAIN.toLowerCase();

  const GET_PAGE_CONTEXT = gql`
    query GET_COMMUNITY_PAGE {
      pageBy(uri: "community?${countryCode}") {
        title
        seo {
          ${seoQuery}
        }
        acf_domains {
          assignedDomains
        }
        uri
        acf_content_builder {
          contentBuilder {
            ... on Page_AcfContentBuilder_ContentBuilder_FcHeroBannerV22023 {
              fieldGroupName
              hb2Banners {
                hb2Title
                hb2Subtext
                hb2Image {
                  ${respImgQuery}
                }
                hb2VideoDesktop {
                  guid
                }
                hb2VideoMobile {
                  guid
                }
                hb2Link {
                  title
                  url
                  target
                }
              }
            }
          }
        }
      }
    }
  `

  const GET_CATEGORIES = gql`
    query GET_CATEGORIE {
      articleCategories {
        nodes {
          name
          slug
          articles(first: 1) {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  `

  const GET_BUYER_ARTICLES = gql`
    query GET_CATEGORIE($slug: String) {
      articleCategories(where: {slug: "buying-guides"}) {
        nodes {
          slug
          id
          name
          articles(first:1000) {
            nodes {
              id
              uri
              title
              date
              articleCategories {
                nodes {
                  name
                  slug
                }
              }
              acf_article {
                artDatePosted
                artTeaserCopy
                artThumbnailImage {
                  ${respImgQuery}
                }
              }
              acf_domains {
                assignedDomains
              }
            }
          }
        }
      }
    }
  `

  const GET_ARTICLES = gql`
    query GET_ARTICLE {
      articles(first:1000) {
        nodes {
          uri
          title
          date
          articleId
          articleCategories {
            nodes {
              name
            }
          }
          acf_article {
            artFeaturedArticle
            artDatePosted
            artTeaserCopy
            artThumbnailImage {
              ${respImgQuery}
            }
          }
          acf_domains {
            assignedDomains
          }
        }
      }
    }
  `

  if (!process.env.DEALER_SITE) {
    const contextProps = await client.query({
      query: GET_PAGE_CONTEXT
    });

    const categoryProps = await client.query({
      query: GET_CATEGORIES
    });

    const pageProps = await client.query({
      query: GET_ARTICLES
    });

    const buyerProps = await client.query({
      query: GET_BUYER_ARTICLES
    });

    if (pageProps) {
      const context = get(contextProps, 'data.pageBy', null);

      const hbData = get(context, 'acf_content_builder.contentBuilder', null);
      const heroBanner = hbData && hbData[0] ? refactorHb(hbData[0]) : null;

      const categoryNodes = get(categoryProps, 'data.articleCategories.nodes', null);

      const categories = categoryNodes ? categoryNodes.filter(item => {
        return get(item, 'articles.edges', []).length > 0 
      }) : null;

      const articles = get(pageProps, 'data.articles.nodes', null);
      const articleItems = articles.filter(article => article.articleCategories && article.articleCategories.nodes.length > 0);
      const filteredArticles = articleItems.filter(article => article.acf_domains.assignedDomains.indexOf(region) !== -1);

      const assignedDomains = get(context, 'acf_domains.assignedDomains', []); 

      const articleConversion = filteredArticles.filter(item => {
        return get(item, 'acf_domains.assignedDomains', []).indexOf(region) !== -1
      }).map(item => {

        const title = item.title;
        const teaser = item.acf_article.artTeaserCopy;
        const uri = item.uri;
        const date = item.date;
        const featured = item.acf_article.artFeaturedArticle;
        const articleID = item.articleId;
        const category = item.articleCategories.nodes[0].name;
        const img = item.acf_article.artThumbnailImage ? refactorRespImg(item.acf_article.artThumbnailImage, [{
          size: 'default',
          key: 'image_size_466x314'
        }]) : null;
    
        return {
          title,
          articleID,
          date,
          teaser,
          uri: uri.replace('-ccau', '').replace('-ccnz', ''),
          featured,
          category,
          img,
        }
      })

      // Buying Guides
      const name = get(buyerProps, 'data.articleCategories.nodes[0].name', null);
      const buyerArticles = get(buyerProps, 'data.articleCategories.nodes[0].articles.nodes', null);

      const buyerArticlesConverted = buyerArticles.filter(item => {
      const articleAssignedDomains = get(item, 'acf_domains.assignedDomains', []);
        return articleAssignedDomains.indexOf(domain) !== -1;
      }).map(item => {
        const title = item.title;
        const teaser = item.acf_article.artTeaserCopy;
        const uri = item.uri ? item.uri.replace('-ccau', '').replace('-ccnz', '') : null;
        const category = item.articleCategories.nodes[0].name;
        const img = item.acf_article.artThumbnailImage ? refactorRespImg(item.acf_article.artThumbnailImage, [{
          size: 'default',
          key: 'image_size_466x314'
        }]) : null;
    
        return {
          id: item.id,
          title,
          teaser,
          uri,
          category,
          img
        }
      })

      const data = {
        meta: {
          title: context.title,
          seo: context.seo,
          assignedDomains
        },
        breadcrumbs: await refactorBreadcrumbsData('/community', assignedDomains),
        heroBanner,
        categories,
        filteredArticles,
        articleConversion,
        countryCode,
        region,
        buyerGuides: {
          name,
          buyerArticlesConverted
        }
      }


      return {
        props: {
          ...data,
        }
      }
    } 
    else {
      return { props: {} }
    }

  } else { 
    const dealerData = {
      breadcrumbs: await refactorBreadcrumbsData('/community', []),
      countryCode,
      region,
    }
    return {
      props: {
        ...dealerData,
      }
    }
  }
}
  
export default Community